import type { ItemList, WithContext } from "schema-dts";
import { ORG } from "@/content/_site.config";

type ItemListOptions = {
  id: string;
  name: string;
  href?: string;
  items: { label: string; href: string }[];
};

export function buildItemListSchema({
  id,
  name,
  href = "",
  items,
}: ItemListOptions): WithContext<ItemList> {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "@id": `${ORG.url}${href}/${id}`,
    url: `${ORG.url}${href}`,
    name,
    numberOfItems: items.length,
    itemListOrder: "https://schema.org/ItemListOrderAscending",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      url: `${ORG.url}${item.href}`,
    })),
  };
}
